import { FormGroup } from '@angular/forms';
import { DskGroupSearchItem, VendorSearchItem } from './global-reference.service';

export function patchDskClassification(form: FormGroup, item: DskGroupSearchItem | null | undefined): void {
  if (!item) {
    return;
  }
  form.patchValue({
    mainGroup: item.mainGroup ?? '',
    productGroup: item.productGroup ?? '',
    subGroup: item.subGroup ?? '',
    dskAssortmentID: item.dskAssortmentID ?? '',
    family: item.family ?? '',
    discountGroup: item.discountGroup ?? ''
  });
}

export function patchVendorFields(form: FormGroup, item: VendorSearchItem | null | undefined): void {
  if (!item) {
    return;
  }
  form.patchValue({
    vendorID: item.vendorID ?? '',
    vendorName: item.vendorName ?? ''
  });
}

export function formatDskSearchOptionLabel(item: DskGroupSearchItem): string {
  const core = [item.mainGroup, item.productGroup, item.subGroup].filter(Boolean).join(' / ');
  const idPart = item.dskAssortmentID ? ` · ${item.dskAssortmentID}` : '';
  return `${core || '—'}${idPart}`;
}

export function formatDskSearchOptionMeta(item: DskGroupSearchItem): string {
  const parts: string[] = [];
  if (item.family) {
    parts.push(`Family: ${item.family}`);
  }
  if (item.discountGroup) {
    parts.push(`Discount: ${item.discountGroup}`);
  }
  return parts.join(' · ');
}
